/* Foreverings -- wishlist page (/apps/wishlist)
   Added 2026-08-27. Loaded only on the wishlist path, from js-variables.liquid.
   Companion file: assets/fe-wishlist-page.css

   Three jobs, all rewording or adding to app-rendered copy:

   1. The signed-out callout ships as "To save your wishlist please login or
      sign up". The wishlist IS saved -- in this browser. What an account buys
      is that it survives moving to another device. It also offers no route to
      registration beyond a gray inline link.

   2. The empty state points at /collections/all, which is 984 products in
      creation order.

   3. The heading is just "Wishlist" with no indication of how much is in it.

   NO COPY HERE MAY SAY "RING".
   The catalogue is mostly rings but not only rings -- there are necklaces,
   earrings and a ring sizer, and productType is empty on every product, so
   there is no reliable way to tell what a saved item is. "4 items saved" and
   "keep your wishlist on any device" are correct whatever someone saved.

   <wishlist-page> is a Lit component that re-renders on every wishlist change,
   which wipes anything we write into it -- hence the MutationObserver. The
   applied counter is a backstop against a render loop: if our own writes ever
   trigger a re-render that triggers our writes again, we stop rather than spin.
   Updating the count text is deliberately outside that counter, because it is a
   text-only change to a node we own and has to stay correct as items come and
   go. */

(function () {
  var MAX_APPLIES = 60;
  var applied = 0;

  function calloutMarkup() {
    return (
      '<div class="fe-save">' +
        '<p><b>Saved on this device.</b> Create an account to keep your ' +
        'wishlist on any device. Already have one? ' +
        '<a href="/account/login">Log in</a>.</p>' +
        '<a class="fe-register" href="/account/register">Create an account</a>' +
      '</div>'
    );
  }

  function emptyMarkup() {
    return (
      '<div class="fe-empty">' +
        '<p class="fe-empty-h">Nothing saved yet</p>' +
        '<p class="fe-empty-p">Tap the heart on anything you like to keep it ' +
        'here while you decide. Your wishlist is shareable, so your partner can ' +
        'see what you picked.</p>' +
        '<div class="fe-chips">' +
          '<a href="/collections/couples-rings">Couples rings</a>' +
          '<a href="/collections/engagement-rings">Engagement rings</a>' +
          '<a href="/collections/men-featured">Mens rings</a>' +
          '<a href="/collections/best-selling-collection">Best sellers</a>' +
        '</div>' +
      '</div>'
    );
  }

  function syncCount(page) {
    var title = page.querySelector('.wk-title');
    if (!title) return;

    var n = page.querySelectorAll('wishlist-product-card').length;
    var span = title.querySelector('.fe-count');

    if (n === 0) {
      if (span) span.remove();
      return;
    }

    var text = n === 1 ? '1 item saved' : n + ' items saved';

    if (!span) {
      span = document.createElement('span');
      span.className = 'fe-count';
      title.appendChild(span);
    }
    if (span.textContent !== text) span.textContent = text;
  }

  function apply(page) {
    syncCount(page);

    if (applied >= MAX_APPLIES) return;

    var callout = page.querySelector('.wk-login-callout');
    if (callout && callout.getAttribute('data-fe') !== '1') {
      callout.setAttribute('data-fe', '1');
      callout.innerHTML = calloutMarkup();
      applied++;
    }

    var empty = page.querySelector('.wk-wishlist-empty-callout');
    if (empty && empty.getAttribute('data-fe') !== '1') {
      empty.setAttribute('data-fe', '1');
      empty.innerHTML = emptyMarkup();
      applied++;
    }
  }

  function start() {
    var page = document.querySelector('wishlist-page');
    if (!page) return false;
    apply(page);
    new MutationObserver(function () { apply(page); })
      .observe(page, { childList: true, subtree: true });
    return true;
  }

  function boot() {
    if (start()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (start() || ++tries > 60) clearInterval(timer);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
